export enum AttributeType {
  double = 'double',
  integer = 'integer',
  string = 'string',
  text = 'text',
  number = 'number',
  domain = 'domain',
  boolean = 'boolean',
  list = 'list',
  date = 'date',
  id = 'id',
  decimalPercent = 'decimalPercent', // for percent values stored as [0..1]
  intPercent = 'intPercent', // for percent values stored as [0..100]
  hasValue = 'hasValue',
  object = 'object',
  action = 'action',
  checkbox = 'checkbox',
  customLabel = 'customLabel',
}
